import { Drawer as AntdDrawer, DrawerProps as AntdDrawerProps } from 'antd';
import React, { ReactNode } from 'react';

import { RenderFooter } from 'components/feedback/drawer/RenderFooter';
import type { ButtonProps as AppButtonProps } from 'components/general/Button';

interface StepProps {
  currentStep: number;
  totalSteps: number;
  strokeColor?: string;
  railColor?: string;
}
export interface FooterButton extends Omit<
  AppButtonProps,
  'children' | 'onClick'
> {
  text: string | ReactNode;
  onClick: NonNullable<AppButtonProps['onClick']>;
}
interface DrawerProps extends Omit<AntdDrawerProps, 'ref' | 'getContainer'> {
  drawerProps?: Partial<AntdDrawerProps>;
  footerActions?: FooterButton[];
  footerExtra?: ReactNode;
  stepProps?: StepProps;
  containerRef?: React.RefObject<HTMLElement | null>;
}

const Drawer: React.FC<DrawerProps> = ({
  className = '',
  drawerProps,
  stepProps,
  footerActions,
  footerExtra,
  width = 500,
  placement = 'right',
  mask = { blur: false },
  containerRef,
  ...rest
}) => {
  const getContainer = containerRef
    ? () => containerRef.current || document.body
    : false;
  const needsAbsolutePosition = containerRef !== undefined;

  return (
    <AntdDrawer
      getContainer={getContainer}
      rootStyle={needsAbsolutePosition ? { position: 'absolute' } : undefined}
      size={width as DrawerProps['size']}
      placement={placement}
      maskClosable
      destroyOnHidden
      mask={mask}
      className={`${className} ant-drawer-custom`}
      rootClassName="drawer-root"
      footer={
        <RenderFooter
          footerActions={footerActions}
          footerExtra={footerExtra}
          stepProps={stepProps}
        />
      }
      {...drawerProps}
      {...rest}
    />
  );
};

Drawer.displayName = 'Drawer';

export { Drawer };
